import { render, staticRenderFns } from "./AliLogin.vue?vue&type=template&id=676bc18b&scoped=true"
import script from "./AliLogin.vue?vue&type=script&lang=js"
export * from "./AliLogin.vue?vue&type=script&lang=js"
import style0 from "./AliLogin.vue?vue&type=style&index=0&id=676bc18b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bc18b",
  null
  
)

export default component.exports